
import { askApi } from '@/api/index'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { MARKET_CFG } from '@/websocket/quotationWebsocket'
const store = useStore()
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function addStock(e: any, row: any, loginInfo: { serverId: string, token: string }) {
  if (!e || !e.id) return
  const data: any = {}
  data.data = new FormData()
  // data.data.append('ids', route.query.serverid || route.query.serverId)
  data.data.append('ids', e.id)
  data.data.append('json', JSON.stringify([{
    eicode: '',
    securityNo: row.Inst || row.code,
    securityName: row.Name,
    securityMarket: row.Exch,
    exchange: row.Inst.toLocaleUpperCase() + 'A'
  }]))
  data.data.append('serverId', loginInfo.serverId)
  data.data.append('token', loginInfo.token)
  const _data: any = {
    ids: e.id,
    json: JSON.stringify([{
      eicode: '',
      securityNo: row.Inst || row.code,
      securityName: row.Name,
      securityMarket: row.Exch,
      exchange: row.Inst.toLocaleUpperCase() + 'A'
    }]),
    serverId: loginInfo.serverId,
    token: loginInfo.token
  }
  const _signature:any = []
  // 不兼容49版本谷歌
  // for (const key of data.data.keys()) {
  //   _signature.push(data.data.get(key))
  // }
  for (const key in _data) {
    _signature.push(_data[key])
  }
  const _time: any = '' + parseInt((new Date().getTime() / 1000) as any) * 1000
  data.headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    timestamp: _time,
    signature: window.Md5.hashStr('sjdxfnqogbzoun13d971ckh8p' + _signature.join('') + _time)
  }
  return askApi.addStock(data).then((res: any) => {
    if (res.code === 1) {
      // 通知原生
      window.open('gw://funccall?funcname=OnSelfStockChange')
    }
    return res.code
  })
}
// 删除自选
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function removeStock(ids: any, row: any, loginInfo: { serverId: string, token: string }) {
  const data: any = {}
  // data.data = {}
  data.data = new FormData()
  // data.data.append('ids', route.query.serverid || route.query.serverId)
  data.data.append('id', ids.join(','))
  data.data.append('json', JSON.stringify([{
    securityNo: row.Inst || row.code,
    securityName: row.Name,
    securityMarket: row.Exch
  }]))
  data.data.append('serverId', loginInfo.serverId)
  data.data.append('token', loginInfo.token)
  const _data: any = {
    id: ids.join(','),
    json: JSON.stringify([{
      securityNo: row.Inst || row.code,
      securityName: row.Name,
      securityMarket: row.Exch
    }]),
    serverId: loginInfo.serverId,
    token: loginInfo.token
  }
  const _signature:any = []
  // for (const key of data.data.keys()) {
  //   _signature.push(data.data.get(key))
  // }

  for (const key in _data) {
    _signature.push(_data[key])
  }
  const _time: any = '' + parseInt((new Date().getTime() / 1000) as any) * 1000
  data.headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    timestamp: _time,
    signature: window.Md5.hashStr('sjdxfnqogbzoun13d971ckh8p' + _signature.join('') + _time)
  }
  return askApi.deleteStock(data).then((res: any) => {
    if (res.code === 1) {
      // 通知原生
      window.open('gw://funccall?funcname=OnSelfStockChange')
    }
    return res.code
  })
}
// 获取自选分组列表
// 自选列表
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function getzixuan(loginInfo: { serverId: string, token: string }) {
  const data: any = {}
  data.data = new FormData()
  /* {
    token: '5C16E8A05237C9BB4BDCCA78C93A6C55',
    serverId: '200'
  }
  */
  // const obj: any = {
  //   serverId: pageData.serverId,
  //   token: pageData.token
  // }
  store.commit('setLoginInfo', {
    token: loginInfo.token,
    serverId: loginInfo.serverId
  })
  data.data.append('serverId', loginInfo.serverId)
  data.data.append('token', loginInfo.token)
  const _data: any = {
    serverId: loginInfo.serverId,
    token: loginInfo.token
  }
  const _signature: any = []
  // for (const key of data.data.keys()) {
  //   _signature.push(data.data.get(key))
  // }
  for (const key in _data) {
    _signature.push(_data[key])
  }
  const _time: any = '' + parseInt((new Date().getTime() / 1000) as any) * 1000
  data.headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    timestamp: _time,
    signature: window.Md5.hashStr('sjdxfnqogbzoun13d971ckh8p' + _signature.join('') + _time)
  }
  askApi.getgroupall(data).then((res: any) => {
    if (res.data) {
      store.commit('setOptionalShareslist', res.data)
    }
  })
}
// 跳转至时分------合约详情
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function gotoDetail(row: any) {
  let url = ''
  if (row.Exch && row.Inst) {
    url = `gw://funccall?funcname=OnGoFenshi;param0=${row.Exch};param1=${row.Inst}`
    window.open(url)
  }
}
// 跳转至原生登录
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function gotoClientLogin() {
  window.open('gw://funccall?funcname=OnUserLogin')
}
// 跳转至K线
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function gotoKline(row: any, period?: string | undefined) {
  let url = ''
  if (row.Exch && row.Inst) {
    const periodstr = period || 'DAY'
    // periodstr 周期 1MIN，5MIN，15MIN，30MIN，60MIN，DAY，WEEK，MONTH，SEASON
    const Exch = row.Exch.toLocaleLowerCase() === 'sz' ? '0' : row.Exch.toLocaleLowerCase() === 'sh' ? '1' : '2'
    url = `gw://funccall?funcname=OnFireCommand;Command=kline.L2;param=<params><kline_special_event>0</kline_special_event><StyleName>JSFX</StyleName><code>${row.Inst}</code><market>${Exch}</market><periodstr>${periodstr}</periodstr><TabName>K线图</TabName><flag_container_style>K</flag_container_style><update_current_stock>1</update_current_stock></params>`
    // update_current_stock 为特殊参数，通知原生保存当前双击的股票，如后续页面不需要该参数，则改为可配置
    window.open(url)
  }
}


// 根据market id获取对应的键名
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function getMarketKeyById(id: number | string): string | null {
  const idNum = typeof id === 'string' ? parseInt(id) : id
  
  // 遍历MARKET_CFG查找匹配的id
  for (const [key, value] of Object.entries(MARKET_CFG)) {
    if (value as any && typeof value === 'object' && 'id' in (value as any) && (value as any).id === idNum) {
      return key
    }
    
    // 处理嵌套的EUIDX情况
    if (key === 'EUIDX' && value && typeof value === 'object' && 'code' in value) {
      const euidxValue = value as { code: Record<string, { id: number }> }
      for (const [subKey, subValue] of Object.entries(euidxValue.code)) {
        if (subValue && subValue.id === idNum) {
          return subKey
        }
      }
    }
  }
  
  return null
}


/**
 * 百分比格式化：截断到2位小数，不四舍五入
 * @param val 小数形式的比率，如 0.1234 => '12.34%'
 */
function formatPctTrunc(val: number | null | undefined, suffix = '%'): string {
  if (val == null) return '--'
  const truncated = Math.trunc(val * 10000) / 100
  return truncated.toFixed(2) + suffix
}

export default {
  addStock,
  removeStock,
  getzixuan,
  gotoDetail,
  gotoClientLogin,
  gotoKline,
  getMarketKeyById,
  formatPctTrunc,
}

export {
  addStock,
  removeStock,
  getzixuan,
  gotoDetail,
  gotoClientLogin,
  gotoKline,
  getMarketKeyById,
  formatPctTrunc,
}
